module.exports = "/_next/static/resources/blavka-2-8a7f6e5f88d3cd315116b6c19816fb1b.jpg";